import { FunctionComponent, useEffect, useState } from "react";
import CategoryContainer from "../../components/Category/CategoryContainer";
import Footer from "../../components/Footer";
import { useParams } from "react-router-dom";
import { ProductServices } from "../../services/products";
import { useAsync } from "../../utils/hooks/useAsync";
import Loading from "../../components/common/Loading";


type MultiSelectResponse = {
  data: MultiSelectOption[]
}

const Category: FunctionComponent = ({}) => {
  const { category } = useParams();
  const { isLoading, isSuccess, data, run } = useAsync<MultiSelectResponse, any>();

  useEffect(() => {
    run(ProductServices.getCategoriesbyDepartment(category || ""));
  }, []);
  
  return (
    <>
      {isLoading && <Loading />}
      {isSuccess && data && data.data && data.data.length > 1 && (
        <CategoryContainer subcategoryOptions={data.data} />
      )}
      <Footer />
    </>
  );
};

export default Category;
